import {Cato} from '../cato/cato';
import {MultiLang} from '../../../../admin/models/multiLang';

export class CenterCollege extends MultiLang {
  public state: MultiLang = new MultiLang();
  public type: MultiLang = new MultiLang();
  public form: MultiLang = new MultiLang();
  public cato: Cato = new Cato();
  public openYear: number;
  public closeYear: number;
  public creationType: MultiLang = new MultiLang();
  public combinedUniversityList: CenterCollege[] = [];
  public separatedUniversity: CenterCollege;
  public closeReason: MultiLang = new MultiLang();
  public afterSeparateCount: number;
  public universityJoinedWith: CenterCollege;
  public joinedUniversityList: CenterCollege[] = [];
  public afterSeparateUniversityList: CenterCollege[] = [];
  public responsibleForDoc: boolean;
  public url: string;
  public urlForRegEnrolls: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/university/center-college.ts